<template>
  <div>
    <b-row>
      <b-table
        id="tablaLicencias"
        ref="tablaLicencias"
        striped
        responsive
        hover
        select-mode="single"
        stacked="md"
        :items="licenciasProvider"
        :fields="fieldsTablaLicencias"
        :filter="SearchTerm"
        :current-page="currentPage"
        :per-page="perPage">
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.key === 'PersonalString'? '25%' : field.key === 'ListaCargoPersonalString' ? '40%' : field.key === 'TipoLicencia.Articulo' ? '15%' : '5%' }"
          >
        </template>
        <template #cell(FechaSolicitud)="row">{{ row.value | moment('DD/MM/YYYY') }}</template>
        <template #cell(LicenciaDesde)="row">{{ row.value | moment('DD/MM/YYYY') }}</template>
        <template #cell(LicenciaHasta)="row">{{ row.value | moment('DD/MM/YYYY') }}</template>
        <template #cell(ListaCargoPersonalString)="row">
          {{ row.value[0] }}  <b-badge :id="'cp-' + row.item.Id" v-if="row.value.length > 1"> {{ row.value.length - 1 }}+</b-badge>
          <b-tooltip v-if="row.value.length > 1" :target="'cp-' + row.item.Id" placement="bottom">
            <span>{{ row.value.slice(1).join('\n') }}</span>
          </b-tooltip>
        </template>
        <template #cell(Acciones)="row">
          <b-dropdown id="ddown-divider" right text="Acciones" size="sm" variant="primary">
            <b-dropdown-item-button v-show="!row.detailsShowing"
              @click.stop="rowClick(row.item, row.index, row.detailsShowing, row.toggleDetails)"
            >Ver detalles</b-dropdown-item-button>
            <!-- <b-dropdown-item-button @click.stop="editarLicencia(row.item, row.index, $event.target)">Editar</b-dropdown-item-button> -->
            <b-dropdown-item-button @click.stop="removerLicencia(row.item)">Eliminar</b-dropdown-item-button>
          </b-dropdown>
        </template>
        <template slot="row-details" slot-scope="row">
          <b-row>
            <b-col>
              <card-detalle-licencia class="mb-2"  :licencia="TablaLicenciaRows[row.index]" :incluyesolicitud="true"></card-detalle-licencia>
              <b-button variant="success" size="sm" @click="row.toggleDetails">Ocultar</b-button>
              <!--<b-button variant="success" size="sm" @click="descargarConstancia(row.item.Id)">
                Descargar constancia
                <b-icon icon="file-earmark-medical"></b-icon>
              </b-button>-->
              <!-- <b-button variant="success" size="sm" @click="emitirConstancia(row.item.Id)">
                Emitir constancia
                <b-icon icon="file-earmark-medical"></b-icon>
              </b-button>
              <b-button v-if="row.item.CantidadDiasRestantes === 0" variant="success" size="sm" @click="emitirConstanciaAlta(row.item.Id)">
                Emitir Alta Médica
                <b-icon icon="file-earmark-medical"></b-icon>
              </b-button> -->
            </b-col>
          </b-row>

        </template>
        <!--Pie de tabla-->
        <template slot="table-caption">
          <small>
            <b>Total Items :</b>
          </small>
          <b-badge variant="success">{{ totalRows }}</b-badge>
          <small>
            |
            <b>Ordenado por :</b>
            {{ sortBy }}
          </small>
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-pagination
          size="sm"
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        ></b-pagination>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal label="Por página: " class="mb-0">
          <b-form-select size="sm" :options="pageOptions" v-model="perPage"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import vuePdfjs from 'vue-pdfjs'
import api from "@/api";
import axios from "axios";
import LicenciaCargoPersonalSvc from "@/services/licenciacargopersonal";
import { createHelpers } from "vuex-map-fields";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import CardDetalleLicencia from './CardDetalleLicencia.vue';

const { mapFields: mapFormLicenciaFields } = createHelpers({
  getterType: "FormLicenciaModule/getLicenciaField",
  mutationType: "FormLicenciaModule/updateLicenciaField"
});


const { mapFields: mapFiltroLicenciaFields } = createHelpers({
  getterType: "FiltroLicenciaModule/getFiltroLicenciaField",
  mutationType: "FiltroLicenciaModule/updateFiltroLicenciaField"
});


const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: "TablaLicencias",
  mixins: [errorhandler, swalerts],
  props: {},
  components: { CardDetalleLicencia, vuePdfjs },
  data() {
    return {
      TablaLicenciaRows: [],
      formulario: {
        modalInfo: {
          title: "",
          content: ""
        }
      },
      totalRows: null,
      fieldsTablaLicencias:[
        {
          key: 'PersonalString',
          label: 'Personal',
        },
        {
          key: 'ListaCargoPersonalString',
          label: 'Cargos',
        },
        {
          key: 'TipoLicencia.Articulo',
          label: 'Artículo',
        },
        {
          key: 'FechaSolicitud',
          label: 'Fecha Solicitud',
        },
        {
          key: 'LicenciaDesde',
          label: 'Desde',
        },
        {
          key: 'LicenciaHasta',
          label: 'Hasta',
        },
        {
          key: 'CantidadDias',
          label: 'Dias otorgados',
          class: 'text-center',
        },
        {
          key: 'Acciones',
          label: 'Acciones',
        },
      ],
      sortBy: "Id",
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, 25]
    };
  },
  watch: {
    getEstablecimiento: function(newvalue, oldvalue) {
      this.$refs.tablaLicencias.refresh();
    },
    FiltroEstablecimiento: function(newvalue, oldvalue) {
      this.$refs.tablaLicencias.refresh();
    },
    TipoLicencia: function(newvalue, oldvalue) {
      this.$refs.tablaLicencias.refresh();
    },
    DetalleDiasLicencia: function(newvalue, oldvalue) {
      this.$refs.tablaLicencias.refresh();
    },
    FechaDesde: function(newvalue, oldvalue) {
      this.$refs.tablaLicencias.refresh();
    }
  },
  computed: {
    ...mapGetters(["getUserInfo", "getUserName", "getEstablecimiento", "isInRoleAdmin"]),
    ...mapFormBuscarPersonalFields(['Personal_Id']),
    ...mapFormLicenciaFields(["TipoLicencia","DetalleDiasLicencia"]),
    ...mapFiltroLicenciaFields({
      FiltroEstablecimiento: 'FiltroEstablecimiento.selected',
      FechaDesde: "FechaDesde",
      FechaHasta: "FechaHasta",
      SearchTerm: "SearchTerm",
    })
  },
  methods: {
    rowClick(item, index, detailsShowing, toggleDetails) {
      console.log("rowClick", detailsShowing, index, toggleDetails);
      this.disabled = true;

      LicenciaCargoPersonalSvc.get({
        id: item.Id,
        incluyecargopersonal: true,
        incluyesolicitud: true
      })
        .then(r => {
          this.TablaLicenciaRows[index] = r.data.objeto;
          toggleDetails();
          console.log('get licencia then',r);

          this.disabled = false;
        })
        .catch(e => {
          console.log("Error rowClick", e);
          this.errorHandler(e);
        });
    },
    descargarConstancia(id) {
      this.disabled = true;

      axios({
        url: api.url + "/LicenciaCargoPersonal/GetConstancia/" + id,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        //link.setAttribute('download', 'constancia.pdf');
        link.setAttribute("download", "constancia.docx");
        document.body.appendChild(link);
        link.click();

        this.disabled = false;
      });
    },
    emitirConstancia(id) {
      axios({
        url: api.url + "/LicenciaCargoPersonal/GetConstanciaPdf/" + id,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        console.log('response', response);
        var blob = new Blob([response.data], {type: 'application/pdf'});
        var blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      });
    },
    emitirConstanciaAlta(id) {
      axios({
        url: api.url + "/LicenciaCargoPersonal/GetConstanciaAltaPdf/" + id,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        console.log('response', response);
        var blob = new Blob([response.data], {type: 'application/pdf'});
        var blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      });
    },

    getFormData(id) {
      return LicenciaCargoPersonalSvc.getFormData(id);
    },
    removerLicencia(item){
      console.log('removerLicencia', item);
      this.$emit('tabla-remover-licencia', item);
      this.showConfirmarDanger(`
        La licencia ${item.Id} sera eliminada.
        ${item.PersonalString}
        ${item.TipoLicenciaString}
        Desde: ${moment(item.LicenciaDesde).format("DD/MM/YYYY")}
        Cantidad de días: ${item.CantidadDias}
        Solicitud: ${item.SolicitudMedica_Id} `, 'Eliminar')
      .then((willDelete) => {
        console.log('then willDelete', willDelete);
        if (willDelete.isConfirmed) {
          this.disabled = true;

          LicenciaCargoPersonalSvc.eliminar({ Id: item.Id }).then(r => {
            console.log('eliminar then', r);
            this.$refs.tablaLicencias.refresh();
            this.showSuccess(r.data.status.mensaje);

            this.disabled = false;
          })
          .catch(e => {
            console.log("Error removerLicencia", e);
            this.errorHandler(e);
          });
        }
      });
    },
    editarLicencia(item, index, button) {
      console.log('editarLicencia', item);
      this.$emit('tabla-editar-licencia', item);
    },
    licenciasProvider() {
      this.disabled = true;

      let promise = LicenciaCargoPersonalSvc.getLista({
        offset: (this.currentPage - 1) * this.perPage,
        limit: this.perPage,
        search: this.SearchTerm,
        incluyecargopersonal: true,
        personal_id: this.Personal_Id,
        tipolicencia_id: this.TipoLicencia ? this.TipoLicencia.Id : 0,
        detallediaslicencia_id: this.DetalleDiasLicencia
          ? this.DetalleDiasLicencia.Id
          : 0,
        order: "desc",
        unidadeducativa_id:  this.FiltroEstablecimiento !== 0
          ? 0 :  this.getEstablecimiento
          ? this.getEstablecimiento.UnidadEducativa_Id
          : 0,
        nivelenseñanza_id:  this.FiltroEstablecimiento !== 0
          ? this.FiltroEstablecimiento :  this.getEstablecimiento
          ? this.getEstablecimiento.NivelEnseñanza_Id
          : 0,
        desde: this.FechaDesde
      });
      return promise
        .then(r => {
          console.log("licenciasProvider then", r);
          const items = r.data.rows;
          this.totalRows = r.data.total;

          this.disabled = false;
          return items;
        })
        .catch(e => {
          console.log("Error licenciasProvider", e);
          this.errorHandler(e);
        });
    }
  }
};
</script>

<style>
  .tooltip-inner {
    max-width: 100% !important;
    white-space:pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/TablaLicencias.vue